import StockModuleSettingPanel from './stockModuleSettingPanel.container';

export default StockModuleSettingPanel;